import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function MyLearningTabs() {
    const navigate = useNavigate();
    const location = useLocation();

    const routeToIndexMap = {
        '/my-learning': 0,
        '/my-learning/completed': 1,
        '/my-learning/certificates': 2,
    };

    const currentTab = routeToIndexMap[location.pathname] || 0;

    const handleTabChange = (event, newValue) => {
        const indexToRouteMap = {
            0: '/my-learning',
            1: '/my-learning/completed',
            2: '/my-learning/certificates',
        };
        navigate(indexToRouteMap[newValue]);
    };

    return (
        <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="My Learning Tabs"
            centered
            sx={{
                borderBottom: 1,
                borderColor: 'divider',
            }}
        >
            <Tab label="Ongoing" />
            <Tab label="Completed" />
            <Tab label="Certificates" />
        </Tabs>
    );
}

export default MyLearningTabs;
